import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TestsService } from '../../Services/Tests/TestsService';
import { isNullOrUndefined } from 'util';
import { BuyerTest } from '../../../Models/Tests/tests.models';


@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss']
})

export class LeaderboardComponent implements OnInit, OnDestroy {

  topTests: BuyerTest[] = [];
  datesList: string[] = [];
  testdetailsPath: string;
  testsuiteName: string;
  pathId: string;
  testName: string;
  topTestsCollectionSize: number;
  pageLength = 50;

  skiptopTests = 0;
  DateSelected: string;
  isMarksSorted = false;
  isDateEndSorted = false;
  isDateStartSorted = false;
  isDataLoaded = false;

  marksSort = true;
  dateStartSort = false;
  dateEndSort = false;
  isTests: boolean;
  isMobileView: boolean;
  windowWidth: number;

  selectedDate: number;

  constructor(private route: ActivatedRoute, private testService: TestsService, private router: Router) { }


  ngOnDestroy(): void {
    localStorage.removeItem('IsTests');
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.DateSelected = 'All';
    this.selectedDate = 0;
    this.pathId = this.route.snapshot.paramMap.get("examPath");
    this.getLeaderBoard();
  }
 

  getLeaderBoard() {
    if (!isNullOrUndefined(localStorage.getItem('IsTests'))) {
      if (localStorage.getItem('IsTests') == 'true') {
        this.isTests = true;
      }
      else {
        this.isTests = false;
      }
    }
    if (!this.isTests) {
      this.pageLength = 15;
    }
    this.testService.getLeaderboard(this.pathId, this.skiptopTests, this.pageLength, this.isTests, this.selectedDate).subscribe((res) => {
      this.topTests = res.BuyerTests;
      this.topTestsCollectionSize = res.TotalRows;
      this.testsuiteName = res.TestSuiteName;
      this.testdetailsPath = 'exams/' + res.TestSuiteDetailsPath;
      let dates: Date[] = res.DatesList;
      if (this.datesList.length == 0) {
        this.datesList.push('All');
        for (let i of dates) {
          let indexDate = new Date(i);
          this.datesList.push((indexDate.getDate().toString().length == 1 ? '0' + indexDate.getDate().toString() : indexDate.getDate().toString()) + '/' + ((indexDate.getMonth() + 1).toString().length == 1 ? '0' + (indexDate.getMonth() + 1).toString() : (indexDate.getMonth() + 1).toString()) + '/' + indexDate.getFullYear());
        }
      }
      if(this.topTests.length > 0)
      {
        this.testName = this.topTests[0].TestName;
      }
      this.isDataLoaded = true;
    })
  }

  getDateslist(dateselected) {
    if (dateselected == 'All') {
      this.selectedDate = 0;
    }
    else {
      let dates: string[] = dateselected.split('/');
      let datestring = dates[2] + dates[1] + dates[0];
      this.selectedDate = parseInt(datestring);
    }
    this.DateSelected = dateselected
    this.getLeaderBoard();
  }

  testdetailsPage() {
    this.router.navigate([this.testdetailsPath]);
  }
  //getNumberofTopTests() {
  //  this.testService.getNumberofTopTests(this.pathId).subscribe((res) => {
  //    this.topTestsCollectionSize = res;

  //  })
  //}

  topTestspageChanged(number) {
    if (number == 1) {
      this.skiptopTests = 0;
    }
    else {
      this.skiptopTests = (number - 1) * this.pageLength;
    }
    this.getLeaderBoard();
  }



  arrayDatestartSort() {
    this.dateStartSort = true;
    this.dateEndSort = false;
    this.marksSort = false;
    if (!this.isDateStartSorted) {
      this.topTests = this.topTests.sort((n1, n2) => (n1.DateStarted > n2.DateStarted ? 1 : -1));
      this.isDateStartSorted = true;
    }
    else if (this.isDateStartSorted) {
      this.topTests = this.topTests.sort((n1, n2) => (n1.DateStarted < n2.DateStarted ? 1 : -1));
      this.isDateStartSorted = false;
    }
  }


  arrayDateendSort() {
    this.dateStartSort = false;
    this.dateEndSort = true;
    this.marksSort = false;
    if (!this.isDateEndSorted) {
      this.topTests = this.topTests.sort((n1, n2) => (n1.DateEnded > n2.DateEnded ? 1 : -1));
      this.isDateEndSorted = true;
    }
    else if (this.isDateEndSorted) {
      this.topTests = this.topTests.sort((n1, n2) => (n1.DateEnded < n2.DateEnded ? 1 : -1));
      this.isDateEndSorted = false;
    }
  }


  arrayMarksSort() {
    this.dateStartSort = false;
    this.dateEndSort = false;
    this.marksSort = true;
    if (!this.isMarksSorted) {
      if (this.isTests) {
        this.topTests = this.topTests.sort((n1, n2) => (n1.MarksScored > n2.MarksScored ? 1 : -1));
      }
      else {
        this.topTests = this.topTests.sort((n1, n2) => (n1.TotalMarks > n2.TotalMarks ? 1 : -1));
      }
      this.isMarksSorted = true;
    }
    else if (this.isMarksSorted) {
      if (this.isTests) {
        this.topTests = this.topTests.sort((n1, n2) => (n1.MarksScored < n2.MarksScored ? 1 : -1));
      }
      else {
        this.topTests = this.topTests.sort((n1, n2) => (n1.TotalMarks < n2.TotalMarks ? 1 : -1));
      }
      this.isMarksSorted = false;
    }
  }

  ngAfterViewInit(): void {
    this.OnResize();
  }

  @HostListener("window:resize")
  private OnResize() {
    this.windowWidth = window.innerWidth;
    if (this.windowWidth <= 420) {
      this.isMobileView = true;
    }
    else {
      this.isMobileView = false;
    }
  }

}
